const removeSeconds = (time: string): string => {
  return time.split(":").slice(0, 2).join(":");
};

export default removeSeconds;
